import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import ShortContentFullToolRecommendations from '../../toolRecommendations/components/ShortsRecommendations/ShortContentFullToolRecommendations';
import { useGetToolRecommendations } from '../../toolRecommendations/hooks/softwareDiscoveryHooks';
import { useResponsiveToolDisplay } from '../../toolRecommendations/hooks/useResponsiveToolDisplay';
import { VideoRecommendationsForLearningContent } from '../../recommendations/components/VideoRecommendationsForLearningContent';
import { jsx as _jsx } from "react/jsx-runtime";
export const ShortContentCompletedVideoView = ({
  short,
  isInCollection = false
}) => {
  const {
    isDesktop
  } = useMediaQuery();
  const {
    contentId,
    language,
    name = '',
    useCases = []
  } = short || {};
  const toolRecommendations = useGetToolRecommendations(useCases);
  const toolsToDisplay = useResponsiveToolDisplay({
    collectionType: isInCollection ? 'shortPlaylist' : undefined
  });
  const shouldShowToolRecommendations = !!(isDesktop && toolRecommendations && toolsToDisplay);
  return contentId && short ? /*#__PURE__*/_jsx(VideoRecommendationsForLearningContent, {
    id: contentId,
    isInCollection: isInCollection,
    language: language,
    moreTitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.shortContent.moreTitle"
    }),
    render: recommendationsContent => shouldShowToolRecommendations ? /*#__PURE__*/_jsx(ShortContentFullToolRecommendations, {
      contentName: name,
      toolsToDisplay: toolsToDisplay,
      useCases: useCases
    }) : recommendationsContent,
    type: "SHORT_FORM_CONTENT"
  }) : null;
};
export default ShortContentCompletedVideoView;